/**
 * One campaign as a phone/tablet card. The card itself is the link, or a plain
 * card for staff who may not edit campaigns. Ended campaigns are dimmed.
 */
import { TicketSalesCampaignStatus } from '@bonsai/shared';
import { Link } from 'react-router-dom';

import type { CampaignListRow } from '../ticket-sales-campaigns-list-model';
import { campaignEditPath } from '../ticket-sales-campaigns-paths';

import { TicketSalesCampaignCardContent } from './TicketSalesCampaignCardContent';

export interface TicketSalesCampaignCardProps {
  row: CampaignListRow;
  now: Date;
  canOpen: boolean;
}

export function TicketSalesCampaignCard({ row, now, canOpen }: TicketSalesCampaignCardProps) {
  const { campaign, status } = row;
  const style = {
    display: 'block',
    color: 'inherit',
    textDecoration: 'none',
    background: 'var(--nb-bg)',
    border: '1px solid var(--nb-border)',
    borderRadius: 12,
    padding: '13px 14px',
    opacity: status === TicketSalesCampaignStatus.ENDED ? 0.8 : 1,
  } as const;
  const content = <TicketSalesCampaignCardContent row={row} now={now} showChevron={canOpen} />;

  if (!canOpen) return <article style={style}>{content}</article>;
  return (
    <Link
      to={campaignEditPath(campaign.id)}
      aria-label={`Open campaign ${campaign.name}`}
      style={style}
    >
      {content}
    </Link>
  );
}
